import React from 'react';
import EditSolicitationProvider from '../../components/apis/edit-solicitation-provider';
import AssignQuantityTable from './assign-quantity-table';
import Breadcrumbs from '../../../../widgets/breadcrumbs';
import SolicitationNotification from '../../utils/solicitation-notification';
import { breadcrumbsPath } from '../../utils/solicitation-helpers';

const AssignQuantityToStandardItems = () => {
  return (
    <>
      <Breadcrumbs current="Edit Solicitation" path={breadcrumbsPath} />
      <EditSolicitationProvider step="assignQuantity">
        <SolicitationNotification isModal={false} />
        <AssignQuantityTable />
      </EditSolicitationProvider>
    </>
  );
};

export default AssignQuantityToStandardItems;
